import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, Hammer, FileText, CreditCard, Settings, Shield } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { cn } from '../../utils/formatters';

export function BottomNav() {
  const location = useLocation();
  const { user } = useAuth();

  const navigation = [
    { name: 'Inicio', href: '/dashboard', icon: LayoutDashboard },
    { name: 'Clientes', href: '/clients', icon: Users },
    { name: 'Proyectos', href: '/projects', icon: Hammer },
    { name: 'Presupuestos', href: '/budgets', icon: FileText },
    { name: 'Gastos', href: '/expenses', icon: CreditCard },
  ];

  const isActive = (href: string) => location.pathname === href || (href !== '/dashboard' && location.pathname.startsWith(href));

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-white/90 dark:bg-secondary-950/90 backdrop-blur-md border-t border-secondary-200 dark:border-secondary-800 md:hidden safe-area-inset-bottom"
      aria-label="Navegación principal móvil"
    >
      <div className="grid grid-cols-5">
        {navigation.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.href);
          return (
            <Link
              key={item.name}
              to={item.href}
              className={cn(
                'flex flex-col items-center justify-center gap-1 px-2 py-2.5 transition-colors',
                active
                  ? 'text-primary-600 dark:text-primary-400'
                  : 'text-secondary-500 dark:text-secondary-400'
              )}
              aria-current={active ? 'page' : undefined}
            >
              <Icon className={cn('w-6 h-6', active && 'fill-current')} strokeWidth={active ? 2.5 : 2} />
              <span className="text-xs font-medium">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}